<template>
  <div>
   <label class="required">{{ label }}</label>
    <div class="ts-border ts-rounded-md ts-p-2">
      <input
        v-model.trim="search"
        type="text"
        placeholder="Search"
        class="form-control"
      />
      <ts-checkbox :checkedValue="isCheckAll" @change="onSelectAll"
        >All</ts-checkbox
      >
      <ul style="height:300px" class="ts-overflow-y-scroll">
        <li v-for="(p, index) in optionsList" :key="index" class="ts-text-xs">
          <ts-checkbox
            v-model="model[valueKey]"
            @change="$emit('change', model[valueKey])"
            :value="p.value"
            >{{ p.label }}</ts-checkbox
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'groupCheckBoxControl',
  props: {
    value: {},
    valueKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isCheckAll() {
      return this.model[this.valueKey].length == this.optionsList.length && this.model[this.valueKey].length > 0
    },
    optionsList() {
      return this.options.filter(
        el => el.label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
      )
    }
  },
  data() {
    return {
      search: '',
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    onSelectAll(value) {
      if (value) {
        this.model[this.valueKey] = []
        this.optionsList.forEach(element => {
          this.model[this.valueKey].push(element.value)
        })
        this.$emit('change', this.model[this.valueKey])
      } else {
        this.model[this.valueKey] = []
        this.$emit('change', this.model[this.valueKey])
      }
    }
  }
}
</script>

<style></style>
